if (typeof Sentry !== 'undefined') {
    Sentry.onLoad(function () {
        const baggage = document.querySelector('meta[name=baggage]').content;
        const settings = new URLSearchParams(baggage.replaceAll(',', '&'));

        Sentry.init({
            release: settings.get('sentry-release'),
            environment: settings.get('sentry-environment'),
            integrations: [
                Sentry.browserTracingIntegration(),
            ],
            tracesSampleRate: settings.get('sentry-sample_rate'),
            profilesSampleRate: 1.0,
            replaysSessionSampleRate: 0,
            replaysOnErrorSampleRate: 0,
            tracePropagationTargets: ['localhost', 'medexel.be', 'mymedexel.be', 'uat-mymedexel.madewithlove.io'],
        });
    });
}
